import { hasSlot } from '../../utils/utils.js';

var script = {
  name: 'PendoDivider',
  props: {
    stroke: {
      type: String,
      default: '#EAECF1'
    },
    strokeWidth: {
      type: Number,
      default: 1
    },
    strokeDasharray: {
      type: String,
      default: null
    },
    height: {
      type: String,
      default: '32px'
    },
    width: {
      type: String,
      default: '100%'
    },
    direction: {
      type: String,
      default: 'horizontal',
      validator: direction => ['horizontal', 'vertical'].includes(direction)
    },
    placement: {
      type: String,
      default: null
    }
  },
  computed: {
    line() {
      if (this.direction === 'vertical') {
        const placement = this.placement || '50%';
        return {
          x1: placement,
          y1: '100%',
          x2: placement,
          y2: '0%'
        };
      }
      const placement = this.placement || '50%';
      return {
        x1: '100%',
        y1: placement,
        x2: '0%',
        y2: placement
      };
    },
    usesSlot() {
      return ['start', 'middle', 'end'].some(slotName => hasSlot(this, slotName));
    }
  }
};

export { script as default };
//# sourceMappingURL=pendo-divider.vue2.js.map
